import { render, staticRenderFns } from "./aufgaben-overview.vue?vue&type=template&id=25534ca0&scoped=true"
import script from "./aufgaben-overview.vue?vue&type=script&lang=js"
export * from "./aufgaben-overview.vue?vue&type=script&lang=js"
import style0 from "./aufgaben-overview.vue?vue&type=style&index=0&id=25534ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25534ca0",
  null
  
)

export default component.exports